import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'src-health-plan-form',
  templateUrl: './health-plan-form.component.html',
  styleUrls: ['./health-plan-form.component.css']
})
export class HealthPlanFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
